<h2 mat-dialog-title>
  {{ 'addBoxInfoDialog.title' | translate }}
</h2>
<mat-dialog-content>
  <div class="text">
    <span [innerHTML]="'addBoxInfoDialog.message' | translate: { name: box.name }"></span>
  </div>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-flat-button cdkFocusInitial (click)="close()">
    {{ 'addBoxInfoDialog.action' | translate }}
  </button>
</mat-dialog-actions>
